<template>
<div class="chapter">
<div class="inner_page">
<div class="box1">
<p class="non"><span class="ss">Dedication</span> I dedicate this book to my son, Brady, lover of all things mystical and magical. His favorite movies involve fantasy creatures. He is my inspiration and my biggest fan.</p>
</div>
<div style="page-break-before:always;"></div>
<div class="box2">
<p class="non" id="ch1"><span class="ss">Acknowledgments</span> A special thank you to my daughter, Jesi. She is a loyal supporter and my right-hand gal. She accompanies me to my many lectures and vending gigs. I would be lost without her super organizational skills.</p>
</div>
<p class="figure-aligncenter-indent"><img alt="image" src="images/pg4_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_dedicationtitle.vue?16109376